import { BaseComponent, BElement } from "utils/base-component"
import "./index.scss"

export class Weski extends BaseComponent {
  static cssClass = "weski"
  private static scriptLoaded = false

  private close!: BElement
  private searchButton?: BElement
  private shownClass!: string

  init() {
    if (!Weski.scriptLoaded) {
      Weski.loadWeskiScript()
      Weski.scriptLoaded = true
    }

    const closeElement = this.element("close-button")
    if (!closeElement) {
      return
    }

    this.close = closeElement
    this.shownClass = `${Weski.cssClass}--shown`

    if (document.cookie.indexOf("weskiClosed=1") === -1) {
      this.root.classList.add(this.shownClass)
    }

    this.close.element.addEventListener("click", (e) => {
      e.preventDefault()
      const expiryDate = new Date()
      expiryDate.setDate(expiryDate.getDay() + 1)

      document.cookie = `weskiClosed=1; expires=${expiryDate.toUTCString()}; path=/`

      this.root.classList.remove(this.shownClass)
    })

    const searchButton = this.element("button")

    if (!searchButton) {
      return
    }
    this.searchButton = searchButton

    if (this.searchButton) {
      this.searchButton.element.addEventListener("click", () => {
        window.dispatchEvent(
          new CustomEvent("openWeskiSearchModal", {
            detail: { direction: "bottom" },
          }),
        )
      })
    }
  }

  private static loadWeskiScript() {
    const script = document.createElement("script")
    script.src = "https://widget.weski.com"
    script.async = true
    document.body.appendChild(script)
  }
}
